angular.module('dnecom')
    .directive('shortCodePicker', ["$http", "$q", "notifications", function ($http, $q, notifications) {
        return {
            templateUrl: 'shortCodePicker.html',
            scope: {
                onSelect: '&',
                onClose: '&',
                placement: '@scpPlacement',
                shortCodes: '=scpShortcodes'
            },
            link: function (scope, element, attrs) {
                scope.select = function(event, shortCode) {
                    event.preventDefault();
                    event.stopPropagation();

                    scope.onSelect({
                        shortCode: shortCode
                    });
                };
            }
        };
    }]);

